module.exports = __webpack_public_path__ + "img/my-life.58b213c9.jpg";